import React from "react";

const Cta = () => (
  <section
    className="gridbg"
    style={{
      padding: "110px 0",
      backgroundColor: "var(--ink)",
      backgroundImage:
        "linear-gradient(to right, rgba(255,255,255,.045) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,.045) 1px, transparent 1px)",
    }}
  >
    <div className="pagewrap tc">
      <div className="mono" style={{ fontSize: 13, color: "#7DD3FC", marginBottom: 20 }}>
        $ book --call mohsin-idrees
      </div>
      <h2 className="disp" style={{ fontSize: "clamp(34px, 4vw, 52px)", fontWeight: 700, letterSpacing: "-.025em", color: "#fff", margin: "0 0 16px" }}>
        Have a project in mind?
        <br />
        Let's talk.
      </h2>
      <p style={{ fontSize: 17, lineHeight: 1.6, color: "#94A3B8", maxWidth: 520, margin: "0 auto 40px" }}>
        Tell me what's slow, manual, or missing, and I'll come back with a plan.
      </p>
      <a href="#contact" className="btn" style={{ background: "var(--accent)", color: "#fff", padding: "17px 36px", fontSize: 16 }}>
        Book a call<span className="arr">→</span>
      </a>
    </div>
  </section>
);

export default Cta;
